/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_CopiedInputs */

const en_us2_wrapped_copied = /** @type {(inputs: Wrapped_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

const pt_br2_wrapped_copied = /** @type {(inputs: Wrapped_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado`)
};

const es_419_wrapped_copied = /** @type {(inputs: Wrapped_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado`)
};

const pt_pt2_wrapped_copied = /** @type {(inputs: Wrapped_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado`)
};

const fr_fr2_wrapped_copied = /** @type {(inputs: Wrapped_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copié`)
};

const de_de2_wrapped_copied = /** @type {(inputs: Wrapped_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiert`)
};

const it_it2_wrapped_copied = /** @type {(inputs: Wrapped_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiato`)
};

/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Wrapped_CopiedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_copied = /** @type {((inputs?: Wrapped_CopiedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_CopiedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_copied(inputs)
	if (locale === "es-419") return es_419_wrapped_copied(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_copied(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_copied(inputs)
	if (locale === "de-DE") return de_de2_wrapped_copied(inputs)
	if (locale === "it-IT") return it_it2_wrapped_copied(inputs)
	return en_us2_wrapped_copied(inputs)
});
export { wrapped_copied as "wrapped.copied" }